import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const responsive = {
  largeDesktop: {
    breakpoint: { max: 4000, min: 1440 },
    items: 8,
    slidesToSlide: 8,
  },
  desktop: {
    breakpoint: { max: 1439, min: 1280 },
    items: 7,
    slidesToSlide: 7,
  },
  laptop: {
    breakpoint: { max: 1279, min: 1080 },
    items: 6,
    slidesToSlide: 6,
  },
  tablet: {
    breakpoint: { max: 1079, min: 836 },
    items: 5,
    slidesToSlide: 5,
  },
  largeMobile: {
    breakpoint: { max: 835, min: 665 },
    items: 4,
    slidesToSlide: 4,
  },
  mediumMobile: {
    breakpoint: { max: 664, min: 476 },
    items: 3,
    slidesToSlide: 3,
  },
  mobile: {
    breakpoint: { max: 475, min: 325 },
    items: 2,
    slidesToSlide: 2,
  },
  smallMobile: {
    breakpoint: { max: 324, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
};

const CustomCarousal = ({ children }) => {
  return (
    <>
      <div className={`w-[100%] m-0 p-0`}>
        <Carousel
          responsive={responsive}
          arrows={true}
          autoPlay={false}
          swipeable={true}
          transitionDuration={100}
          autoPlaySpeed={5000}
          infinite={false}
          pauseOnHover={false}
        >
          {children}
        </Carousel>
      </div>
    </>
  );
};

export default CustomCarousal;
